import { useEffect, useState } from "react";
import { COUPLE } from "@/lib/constants";

function calc(target) {
  const diff = Math.max(0, new Date(target).getTime() - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff / 3600000) % 24);
  const minutes = Math.floor((diff / 60000) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}

const items = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hours" },
  { key: "minutes", label: "Minutes" },
  { key: "seconds", label: "Seconds" },
];

export default function Countdown() {
  const [t, setT] = useState(() => calc(COUPLE.weddingDate));

  useEffect(() => {
    const id = setInterval(() => setT(calc(COUPLE.weddingDate)), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="countdown"
      className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-3xl mx-auto"
    >
      {items.map((it) => (
        <div
          key={it.key}
          data-testid={`countdown-${it.key}`}
          className="glass-card px-3 py-5 md:px-6 md:py-7 text-center group"
        >
          <div className="font-serif text-4xl md:text-6xl gold-text tabular-nums leading-none">
            {String(t[it.key]).padStart(2, "0")}
          </div>
          <div className="mt-3 text-[0.6rem] md:text-[0.65rem] uppercase tracking-[0.4em] text-ivory-dim">
            {it.label}
          </div>
        </div>
      ))}
    </div>
  );
}
